var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollaborations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "{t.collaborations_explore}") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Dashboard---Actions",
    transform: "translate(-51.000000, -353.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Sidebar",
    transform: "translate(30.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Collaboration",
    transform: "translate(21.000000, 231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "icon-collab",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2512696,6.68934462 C15.8957321,6.68934462 15.5460617,7.0030968 15.5460617,7.39014405 C15.5452696,11.6474996 12.5408559,15.0391596 8.63005675,15.0382973 C6.6438975,15.0378866 5.12583897,14.2483796 3.78478449,12.6535034 L6.32865171,11.6285291 C6.66638591,11.5062064 6.8404991,11.0487049 6.72813477,10.6810388 C6.61577045,10.3133726 6.19081919,10.1046486 5.85308498,10.2269713 L1.9906791,11.6285291 C1.72702463,11.7241207 1.54948221,11.9931567 1.55032806,12.295658 L1.55032806,16.5003724 C1.55032806,16.8874197 1.96447576,17.2011719 2.32001324,17.2011719 C2.67555072,17.2011719 3.04219457,16.8874197 3.04219457,16.5003724 L3.04219457,14.1416382 C6.35639531,17.6346308 11.5300208,17.4254164 14.7386088,13.8174921 C16.2507558,12.1171696 17.0041601,9.75677417 17.0001082,7.39014405 C17.0001082,7.0030968 16.606807,6.68934462 16.2512696,6.68934462 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2856583,-9.76996262e-15 C14.9301208,-9.76996262e-15 14.5804505,0.313752181 14.5804505,0.700799434 C14.5796584,4.95815497 11.5752446,8.34981494 7.66444549,8.34895264 C5.67828624,8.34854203 4.16022771,7.55903495 2.81917323,5.96415883 L5.36304045,4.93918448 C5.70077465,4.81686178 5.87488784,4.35936032 5.76252352,3.99169417 C5.65015919,3.62402802 5.22520793,3.41530397 4.88747372,3.53762667 L1.02506784,4.93918448 C0.761413373,5.03477603 0.583870946,5.30381206 0.584716797,5.60631335 L0.584716797,9.81102782 C0.584716797,10.1980751 0.998864502,10.5118273 1.35440198,10.5118273 C1.70993946,10.5118273 2.07658331,10.1980751 2.07658331,9.81102782 L2.07658331,7.45229355 C5.39078405,10.9452862 10.5644095,10.7360718 13.7729976,7.12814751 C15.2851446,5.42782503 16.0385488,3.06742955 16.0344969,0.700799434 C16.0344969,0.313752181 15.6411958,-9.76996262e-15 15.2856583,-9.76996262e-15 Z",
    id: "Path",
    transform: "translate(8.309607, 5.255914) rotate(-180.000000) translate(-8.309607, -5.255914) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborations);
export default __webpack_public_path__ + "static/media/collaborations.7a5deda42717456ef995e492658cba21.svg";
export { ForwardRef as ReactComponent };